<script>
import {h, resolveComponent} from "vue";

export default {
  name: 'widgetWrapper',
  components: {},
  emits: ['more'],
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
    dateItem: {
      type: String,
      default: '',
    },
    more: {
      type: [String, Object],
      default: '',
    },
    info: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {
    onClick() {
      this.$emit('more', this.more);
    },
  },
  render() {
    const {$theme, title, subtitle, prefix, dateItem, more, info} = this;
    const cLabel = resolveComponent('c-label')
    const legoIcon = resolveComponent('lego-icon')
    const legoTooltip = resolveComponent('lego-tooltip')
    const widgetHeaderTitle = h('div', {class: 'widget-header__title'}, [
      prefix &&
      h(
          cLabel,
          {weight: 700, inline: true, size: 20, color: $theme.COLOR.PRIMARY.BASE},
          () => [prefix],
      ),
      h(
          cLabel,
          {weight: 700, inline: true, size: 20, color: $theme.COLOR.UI.UI01},
          () => [title],
      ),
      subtitle &&
      h(cLabel, {weight: 700, inline: true, color: $theme.COLOR.UI.UI05}, () => [
        subtitle,
      ]),

      info &&
      h('span', {class: 'help'}, [
        h(legoIcon, {
          iconType: 'df',
          icon: 'info',
          size: 16,
          id: 'manual',
        }),
        h(legoTooltip, {top: true, mouseOver: true}, () => [info]),
      ]),
    ]);

    const widgetHeaderDate = h(
        'div',
        {
          class: 'widget-header__date',
        },
        [h(cLabel, {size: 12, color: $theme.COLOR.UI.UI05}, () => [dateItem])],
    );

    const widgetHeader = h(
        'div',
        {
          class: 'widget-header',
          style: {borderBottom: `1px solid ${$theme.COLOR.UI.UI08}`},
        },
        [
          widgetHeaderTitle,
          dateItem && widgetHeaderDate,
          more &&
          h(legoIcon, {
            iconType: 'df',
            icon: 'arrow_bar_right',
            size: 16,
            onClick: this.onClick,
          }),
        ],
    );

    const widgetBody = h(
        'div',
        {
          class: 'widget-body',
        },
        [this.$slots.default()],
    );

    return h(
        'div',
        {
          class: 'widget',
        },
        [widgetHeader, widgetBody],
    );
  },
};
</script>

<style scoped lang="scss">
.widget {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid $color--ui08;
  border-radius: 4px;

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 15px 20px;

    .c-label + .c-label {
      margin-left: 8px;
    }

    :deep .opus-icon__info {
      margin-left: 8px;
      position: relative;
      top: 1px;
    }
  }

  &-body {
    flex: 1 1 auto;
    min-width: 0;
  }
}
</style>
